import { BcbsLogo } from "@hcsc-fiber/react";
import React, { useContext } from "react";
import { StateContext } from "../context/stateContext";
import { UsaStatesUpperCase } from "../utils/getStateCode";
import IsLoaded from "./isLoaded1";

export default function Logo() {
  const { stateUSACode = "" } = useContext(StateContext);

  const plan = stateUSACode.toUpperCase() as UsaStatesUpperCase | "";
  return (
    <IsLoaded>
      <BcbsLogo data-testid="logo" plan={plan || undefined} />
    </IsLoaded>
  );
}
